import {reducer as toastrReducer} from "react-redux-toastr";
import { combineReducers } from "redux";

import appReducer from "./appReducer";
import userReducer from "./userReducer";
import alertsReducer from "./alertsReducer";
import schoolReducer from "./schoolReducer";
import setupReducer from "./setupReducer";


const reducers = combineReducers({
  appState: appReducer,
  toastr: toastrReducer,
  userState: userReducer,
  alertsState: alertsReducer,
  schoolState: schoolReducer,
  setupState: setupReducer,
});

export default reducers;